let was_scrolled = false;
let last_scroll_top = 0;

const classes = {
  hide: "hide",
};

const selectors = {
  submitButton: "[data-submit-button]",
  submitButtonText: "[data-submit-button-text]",
  priceWrapper: "[data-price-wrapper]",
  imageWrapper: "[data-product-image-wrapper]",
  visibleImageWrapper: `[data-product-image-wrapper]:not(.${classes.hide})`,
  imageWrapperById: (id) => `${selectors.imageWrapper}[data-image-id='${id}']`,
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
};

$(document).ready(function (e) {
  $(window).on("scroll", on_scroll);
  on_scroll();

  $(window).on("resize", on_resize);
  on_resize();

  Shopify.money_format = "€{{amount}}";

  init_alert();

  init_section_style();
  init_nav();
  init_store_new_tab();

  init_product_form();

  init_galleries();
  init_recover_password();
});

function init_galleries() {
  $(".latest-gallery").flickity({
    // options
    contain: true,
  });
  $(".latest-row-gallery").flickity({
    imagesLoaded: true,
    wrapAround: true,
    cellAlign: "left",
  });
}

/**

var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product ID from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }
    };
    request.send();
};

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
**/

function on_resize() {
  if ($("#product-detail").length > 0) {
    if (
      window.innerWidth > 1024 &&
      $(".flex").height() < $("#product-detail > .container > .row").height()
    ) {
      $("#product-detail > .container > .row").height($(".flex").height());
    }
  }
}

function on_scroll() {
  var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  if (scrollTop > 60) {
    $("nav.main").addClass("scroll");
  } else {
    $("nav.main").removeClass("scroll");
  }

  if (scrollTop > last_scroll_top) {
    $("nav.main").removeClass("show");
  } else if (scrollTop < last_scroll_top) {
    $("nav.main").addClass("show");
    if (scrollTop > $(window).height()) $("nav.main").addClass("filled");
    else $("nav.main").removeClass("filled");
  }

  last_scroll_top = scrollTop;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function init_alert() {
  const cookie_name = "mok_2025_ny";

  console.log(cookie_name, getCookie(cookie_name));
  if (getCookie(cookie_name) == null) {
    // $("body").addClass("alert-open");
  }

  $("#alert").on("click", function (e) {
    e.preventDefault();
    setCookie(cookie_name, "yes", 400);
    window.location = $(this).attr("href");
  });

  $("#close-alert").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setCookie(cookie_name, "yes", 400);
    $("body").removeClass("alert-open");
  });
}

function init_section_style() {
  for (var i = 0; i < $("section:not(.hero)").length; i++) {
    if (i > 1 && i % 2 == 0) {
      $("section:not(.hero)").eq(i).addClass("grey");
    }
  }
}

function init_store_new_tab() {
  $(".store p a").attr("target", "_blank");
}

function init_nav() {
  $(".toggle-menu").on("click", function () {
    $("body").toggleClass("nav-open");
  });
}

function init_recover_password() {
  if (
    window.location.hash == "#recover" &&
    $('[data-action="toggle-recover-password"]').length > 0
  ) {
    $("#login").hide();
    $("#register").hide();
    $("#recover_password").show();
  }

  $('[data-action="toggle-recover-password"]').on("click", function () {
    if ($("#recover_password").is(":visible")) {
      $("#login").show();
      $("#register").show();
      $("#recover_password").hide();
    } else {
      $("#login").hide();
      $("#register").hide();
      $("#recover_password").show();
    }
  });
}

function init_product_form() {
  if ($(".product-option").length == 0) return;

  $(".quantity button").on("click", function (e) {
    var qty = parseInt($(this).parent().find("input").val());

    if ($(this).hasClass("plus")) qty++;
    else qty--;

    qty = Math.max(0, qty);
    $(this).parent().find("input").val(qty);
  });

  $("body").on("change", ".product-option", select_variant);
  select_variant();
}

function getProductJson(handle) {
  return fetch(`/products/${handle}.js`).then((response) => {
    return response.json();
  });
}

function is_matching_variant(variant, options) {
  for (let i = 0; i < options.length; i++) {
    if (variant[options[i].name] != options[i].value) return false;
  }

  return true;
}

function get_variant_from_options() {
  var options = [];

  $(".product-option").each(function () {
    options.push({
      value: $(this).val(),
      name: $(this).data("option"),
    });
  });

  return window.productInfo.variants.find((variant) =>
    is_matching_variant(variant, options)
  );
}

function select_variant(e) {
  var variant = get_variant_from_options();

  if (variant == null) {
    $("#unavailable").show();
    $("#AddToCart").hide();
  } else {
    renderImages(variant);
    $(selectors.productPrice).html(Shopify.formatMoney(variant.price, '{{amount}}'));
    $("#productSelect").val(variant.id);

    $("#unavailable").hide();
    $("#AddToCart").show();
  }
}

function renderImages(variant) {
  if (!variant || variant.featured_image === null) {
    return;
  }

  const activeImage = document.querySelector(selectors.visibleImageWrapper);
  console.log(activeImage);
  const inactiveImage = document.querySelector(
    selectors.imageWrapperById(variant.featured_image.id)
  );
  console.log(activeImage, inactiveImage);

  activeImage.classList.add(classes.hide);
  inactiveImage.classList.remove(classes.hide);
}

function renderPrice(variant) {
  const priceElement = this.container.querySelector(selectors.productPrice);
  const priceWrapperElement = this.container.querySelector(
    selectors.priceWrapper
  );

  priceWrapperElement.classList.toggle(classes.hide, !variant);

  if (variant) {
    priceElement.innerText = formatMoney(variant.price, theme.moneyFormat);
  }
}
function updateBrowserHistory(variant) {
  const enableHistoryState =
    this.productForm.element.dataset.enableHistoryState;

  if (!variant || enableHistoryState !== "true") {
    return;
  }

  const url = getUrlWithVariant(window.location.href, variant.id);
  window.history.replaceState({ path: url }, "", url);
}
